<template>
  <div class="container">
    <div class="mx-auto w-2/3 border-t border-[#a98445]"></div>
  </div>
</template>
